// extracted by mini-css-extract-plugin
module.exports = {"error404":"Error404_error404__2Gknq"};